import { HOW_ZAPIER_WORKS_VIDEO } from '../../constants/stories';
import { createBuilderModule } from '../../builder';
import { WistiaVideo } from './WistiaVideo';

export default createBuilderModule(WistiaVideo, {
  name: 'WistiaVideo',
  image: 'https://cdn.zappy.app/5a5ad454e9f91a5e598ed39722e5e9f8.png',
  inputs: [
    {
      name: 'wistiaId',
      type: 'string',
      defaultValue: HOW_ZAPIER_WORKS_VIDEO,
      helperText:
        'You can grab the Wistia id from the video URL when logged in. Related Wistia docs: https://wistia.com/support/embed-and-share/sharing-videos',
      required: true,
    },
  ],
});
